// Web Push helper — subscribe / unsubscribe a browser to backend push
// notifications. Companion of public/service-worker.js (push listener)
// and backend reminder dispatcher (sendNotification).

const API = 'https://portal.peaksoftcon.com:8081';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

function getCompanyId() {
  try {
    const info = JSON.parse(sessionStorage.getItem('companyInfo') || 'null');
    return info?.ID || null;
  } catch {
    return null;
  }
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function getPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission;
}

export async function isAlreadySubscribed() {
  if (!isPushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error('Bu cihaz/tarayıcı push bildirimi desteklemiyor.');
  const companyId = getCompanyId();
  if (!companyId) throw new Error('Giriş yapılmamış.');

  let permission = Notification.permission;
  if (permission === 'default') {
    permission = await Notification.requestPermission();
  }
  if (permission !== 'granted') throw new Error('Bildirim izni reddedildi.');

  const reg = await navigator.serviceWorker.ready;

  const vapidRes = await fetch(`${API}/api/push/vapidPublicKey`);
  if (!vapidRes.ok) throw new Error('VAPID anahtarı alınamadı.');
  const { publicKey } = await vapidRes.json();
  if (!publicKey) throw new Error('Sunucuda VAPID yapılandırması yok.');

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  const subJson = sub.toJSON();
  const body = {
    companyID: companyId,
    endpoint: subJson.endpoint,
    p256dh: subJson.keys.p256dh,
    auth: subJson.keys.auth,
    userAgent: (navigator.userAgent || '').slice(0, 255),
  };
  const res = await fetch(`${API}/api/push/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error('Sunucuya abonelik kaydı başarısız.');
  return sub;
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  const endpoint = sub.endpoint;
  try { await sub.unsubscribe(); } catch (_) { /* ignore */ }
  try {
    await fetch(`${API}/api/push/unsubscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ endpoint }),
    });
  } catch (_) { /* best-effort */ }
}
